<template>
  <div id="c-confirmation-modal">
    <vp-modal :width="width">
      <template #header>{{ title }}</template>
      <template #default>
        <form :action="submit" @submit.prevent="submit">
          <section>
            <slot>
              <div v-html="compiledBody" ref="body" id="c-confirmation-modal__body" />
            </slot>
            <vp-input v-if="requireInput && !disabled" ref="confirm" v-model="input" required />
          </section>
          <section id="c-confirmation-modal__controls">
            <slot name="controls" v-bind="{ close, submit, confirmed }">
              <vp-button class="no-fill medium blue" @click="close()">Cancel</vp-button>
              <vp-button v-if="!disabled" type="submit" :class="['medium', enableDeleteMode ? 'red' : 'blue']" :disabled="!confirmed">{{text}}</vp-button>
            </slot>
          </section>
        </form>
      </template>
    </vp-modal>
  </div>
</template>

<script>
import VpButton from '../vp-button/VpButton.vue'
import VpInput from '../vp-input/VpInput.vue'
import VpModal from '../vp-modal/VpModal.vue'

export default {
  name: 'ConfirmationModal',
  inject: ['close'],
  props: {
    $toast: { type: Object, default: null },
    method: { type: Function, default: null },
    title: { type: String, default: 'Confirmation Modal' },
    body: { type: String, default: '' },
    width: { type: String, default: '800px' },
    text: { type: String, default: 'delete' },
    enableDeleteMode: { type: Boolean, default: false },
    requireInput: { type: Boolean, default: false },
    safeWord: { type: String, default: 'Permanently Delete' },
    disabled: { type: Boolean, default: false },
    disableCompiledBody: { type: Boolean, default: false },
  },
  components: {
    VpButton, VpInput, VpModal,
  },
  data: () => ({ input: '' }),
  computed: {
    confirmed() {
      const match = this.input.trim().toLowerCase() === this.safeWord.trim().toLowerCase();
      return this.requireInput ? match : true;
    },
    compiledBody() {
      const body = [];

      if (this.disabled || this.disableCompiledBody) return `<p>${this.body}</p>`;
      if (this.body) {
        const char = [',', '?', '.'].includes(this.body[this.body.length - 1]) ? '' : ',';
         body.push(`${this.body + char} <i>this action cannot be undone.</i>`);
      }

      if (this.requireInput) body.push(`Please confirm this by typing <strong>${this.safeWord}</strong> in the input below.`);
      else body.push(`Please confirm this by clicking the "${this.text}" button below.`);

      if (this.enableDeleteMode) body.push(`If you do not wish to delete this item,`)
      else body.push(`If you do not wish to confirm your changes`)

      body.push('please click the "Cancel" button or close this modal.');

      return ['<p>', ...body, '</p>'].join(' ');
    },
  },
  methods: {
    async submit() {
      if (this.method && this.confirmed) await this.method();
      if (this.method && !this.confirmed && this.$toast) return this.$toast.show('info', { title: `Please input ${this.safeWord} to submit` });
      return this.close();
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/mixins.scss';
#c-confirmation-modal {
  &__body {
    display: flex;
    flex-direction: column;
  }

  form {
    display: flex;
    flex-direction: column;
    section {
      margin: 0;
      padding: 1.25rem;
      .vcl-input {
        margin-top: 1rem;
      }
    }
  }
  p {
    margin: 0;
  }
  &__controls {
    gap: 1.25rem;
    display: flex;
    flex-wrap: wrap;
    margin-top: 1rem;
    margin-bottom: 1rem;
    justify-content: center;
    border-top: #DBDBDB 1px solid;
    padding: 1.5rem 0 2.25rem !important;
    & > button {
      min-width: 160px;
      @include Mobile--Only {
        flex-basis: 100%;
      }
    }
  }
  .vcl-modal {
    &__title {
      padding: 1.5rem 1.25rem;
    }
    &__body {
      padding: 0;
    }
    &__buttons {
      padding: 0;
    }
  }

}
</style>
